import { render, staticRenderFns } from "./FbStatusContent.vue?vue&type=template&id=056e1ea4"
import script from "./FbStatusContent.vue?vue&type=script&lang=js"
export * from "./FbStatusContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports